export enum ReasonBdpRollback {
  DATA_UPDATE = 'modules.data-management.serien-daten.modal.bdp-activation-reason-dataupdate',
  FAULTY_BDP = 'modules.data-management.serien-daten.modal.bdp-activation-reason-wrongbdp',
  OTHER = 'modules.data-management.serien-daten.modal.bdp-activation-reason-other',
}
